import servo from "./servo"

export const checklistListExpand = "datoschecklists.areas,datoschecklists.carros,datoschecklists.empresas"
const documentExpand = checklistListExpand + ",detallechecklists,gasolinachecklists.notas,checklistsarchivos.archivos,firmachecklists.archivos"

export async function getChecklistDocumentData(idChecklist) {
  const params = new URLSearchParams({ idChecklist: String(idChecklist), expand: documentExpand })
  const response = await servo.get("checklists?" + params.toString())
  const checklist = response?.cuerpo?.resultado?.[0]
  if (!checklist || String(checklist.idChecklist) !== String(idChecklist)) {
    throw new Error("No fue posible cargar el checklist para generar el documento.")
  }
  return checklist
}
